import React from 'react'
import { useNavigate } from 'react-router-dom'

const SubHeader = ({ message }) => {
    const navigate = useNavigate();

    return (
        <>
            <section className='subheader-bg'>
                <div className='container'>
                    <p className='subheader-text'>{message}</p>
                    {/* <p><span className='cursor-pointer' onClick={() => navigate('/')} >Home</span>
                    <i class="fa-solid fa-angles-right mx-2"></i>{message}</p> */}
                </div>
            </section>
        </>
    )
}

export default SubHeader
